// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1__fef6efa6974fc8e3c5c5{/*!*/}.Unibrow-cls2___b77cef9539f2631140b{display:flex;align-items:center;justify-content:center;flex:1 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1__fef6efa6974fc8e3c5c5",
	"cls2": "Unibrow-cls2___b77cef9539f2631140b Unibrow-cls1__fef6efa6974fc8e3c5c5"
};
export default ___CSS_LOADER_EXPORT___;
